/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { OutDealDTO } from "./OutDealDTO";
import { OutDealDTOFromJSON, OutDealDTOFromJSONTyped, OutDealDTOToJSON } from "./OutDealDTO";
import type { UserRoleDTO } from "./UserRoleDTO";
import { UserRoleDTOFromJSON, UserRoleDTOFromJSONTyped, UserRoleDTOToJSON } from "./UserRoleDTO";

/**
 *
 * @export
 * @interface OutPublicUserWithTokenDTO
 */
export interface OutPublicUserWithTokenDTO {
  /**
   *
   * @type {UserRoleDTO}
   * @memberof OutPublicUserWithTokenDTO
   */
  role: UserRoleDTO;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithTokenDTO
   */
  company?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithTokenDTO
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithTokenDTO
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithTokenDTO
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithTokenDTO
   */
  phone?: string;
  /**
   *
   * @type {number}
   * @memberof OutPublicUserWithTokenDTO
   */
  id: number;
  /**
   *
   * @type {Array<OutDealDTO>}
   * @memberof OutPublicUserWithTokenDTO
   */
  deals: Array<OutDealDTO>;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithTokenDTO
   */
  publicToken: string;
}

/**
 * Check if a given object implements the OutPublicUserWithTokenDTO interface.
 */
export function instanceOfOutPublicUserWithTokenDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "role" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "deals" in value;
  isInstance = isInstance && "publicToken" in value;

  return isInstance;
}

export function OutPublicUserWithTokenDTOFromJSON(json: any): OutPublicUserWithTokenDTO {
  return OutPublicUserWithTokenDTOFromJSONTyped(json, false);
}

export function OutPublicUserWithTokenDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutPublicUserWithTokenDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    role: UserRoleDTOFromJSON(json["role"]),
    company: !exists(json, "company") ? undefined : json["company"],
    firstName: !exists(json, "firstName") ? undefined : json["firstName"],
    lastName: !exists(json, "lastName") ? undefined : json["lastName"],
    email: json["email"],
    phone: !exists(json, "phone") ? undefined : json["phone"],
    id: json["id"],
    deals: (json["deals"] as Array<any>).map(OutDealDTOFromJSON),
    publicToken: json["publicToken"]
  };
}

export function OutPublicUserWithTokenDTOToJSON(value?: OutPublicUserWithTokenDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    role: UserRoleDTOToJSON(value.role),
    company: value.company,
    firstName: value.firstName,
    lastName: value.lastName,
    email: value.email,
    phone: value.phone,
    id: value.id,
    deals: (value.deals as Array<any>).map(OutDealDTOToJSON),
    publicToken: value.publicToken
  };
}
